import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { useAuth } from './AuthProvider';

const TeamManagement = () => {
  const { currentUser, role } = useAuth();
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ email: '', password: '', role: 'inspector' });
  const db = getFirestore();
  const auth = getAuth();

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, 'roles'));
      const userList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsers(userList);
    };

    fetchUsers();
  }, []);

  const handleAddUser = async () => {
    if (!newUser.email || !newUser.password) {
      alert('Email and password are required');
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, newUser.email, newUser.password);
      const uid = userCredential.user.uid;

      await addDoc(collection(db, 'roles'), {
        uid: uid,
        role: newUser.role
      });

      alert('User created successfully');
      window.location.reload(); // Refresh the list
    } catch (error) {
      console.error('Error creating user:', error);
      alert(error.message);
    }
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      await deleteDoc(doc(db, 'roles', userId));
      setUsers(users.filter(user => user.id !== userId));
    }
  };

  if (!currentUser || role !== 'admin') {
    return <div>Access Denied</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Team Management</h1>

      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Add New User</h2>
        <div className="flex flex-col gap-2">
          <input
            type="email"
            placeholder="Email"
            className="border p-2 rounded"
            value={newUser.email}
            onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          />
          <input
            type="password"
            placeholder="Password"
            className="border p-2 rounded"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          />
          <select
            className="border p-2 rounded"
            value={newUser.role}
            onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
          >
            <option value="inspector">Inspector</option>
            <option value="admin">Admin</option>
          </select>
          <button className="bg-blue-500 text-white p-2 rounded" onClick={handleAddUser}>
            Add User
          </button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">Current Users</h2>
        {users.map(user => (
          <div key={user.id} className="flex justify-between items-center border p-2 rounded mb-2">
            <div>
              <div><strong>UID:</strong> {user.uid}</div>
              <div><strong>Role:</strong> {user.role}</div>
            </div>
            <button
              className="bg-red-500 text-white p-2 rounded"
              onClick={() => handleDeleteUser(user.id)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamManagement;
